import React from "react";
import { useTranslation } from 'react-i18next';

function AccountEditPage(props) {

    var { t } = useTranslation();

    return (
        <div>
            <div className="uk-container uk-margin-small-top">
                <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-border-rounded">
                    <h2 className="uk-card-title uk-text-center uk-margin">
                        Edit Account Credentials
                    </h2>

                    <form className="uk-form-stacked">

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="name">
                                Name
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="name"
                                    name="name"
                                    type="text"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="email">
                                Email
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="email"
                                    name="email"
                                    type="email"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="phoneNumber">
                                Phone Number (include +)
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="password">
                                Password
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="password"
                                    name="password"
                                    type="password"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="cityOfOrigin">
                                City of Origin
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="cityOfOrigin"
                                    name="cityOfOrigin"
                                    type="text"
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="age">
                                Age
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="age"
                                    name="age"
                                    type="number"
                                    min="0"
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="educationLevel">
                                Education Level
                            </label>
                            <div className="uk-form-controls">
                                <select
                                    className="uk-select"
                                    id="educationLevel"
                                    name="educationLevel"
                                >
                                    <option value="">Select</option>
                                    <option value="Zero">Zero</option>
                                    <option value="Elementary School">Elementary School</option>
                                    <option value="High School">High School</option>
                                    <option value="Bachelor">Bachelor</option>
                                    <option value="Master">Master</option>
                                    <option value="PhD">PhD</option>
                                </select>
                            </div>
                        </div> 

                        <div className="uk-margin uk-text-center">
                            <button
                                type="submit"
                                className="uk-button uk-button-primary uk-button-jai"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AccountEditPage;